// Chakra imports
import { Flex, Icon, Link, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import React from "react";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import { useAuth } from "secure/AuthContext";

const ProfileInformation = ({
  title,
  description,
  name,
  mobile,
  email,
  location,
}) => {
  const { user } = useAuth()
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card p='16px' my={{ sm: "24px", xl: "0px" }}>
      <CardHeader p='12px 5px' mb='12px'>
        <Text fontSize='lg' color={textColor} fontWeight='bold'>
          {title}
        </Text>
      </CardHeader>
      <CardBody px='5px'>
        <Flex direction='column'>
          {/* <Text fontSize='md' color='gray.500' fontWeight='400' mb='30px'>
            {description}
          </Text> */}
          <Flex align='center' mb='18px'>
            <Text fontSize='md' color={textColor} fontWeight='bold' me='10px'>
              Nom Complet:{" "}
            </Text>
            <Text fontSize='md' color='gray.500' fontWeight='400'>
              {user?.user.fullName || ""}
            </Text>
          </Flex>
          <Flex align='center' mb='18px'>
            <Text fontSize='md' color={textColor} fontWeight='bold' me='10px'>
              Email:{" "}
            </Text>
            <Text fontSize='md' color='gray.500' fontWeight='400'>
              {user?.user.email || ""}
            </Text>
          </Flex>
          <Flex align='center' mb='18px'>
            <Text fontSize='md' color={textColor} fontWeight='bold' me='10px'>
              Crée le:{" "}
            </Text>
            <Text fontSize='md' color='gray.500' fontWeight='400'>
              {new Date(user?.user.createdAt).toLocaleDateString("fr-FR", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Text>
          </Flex>
          {/* <Flex align='center' mb='18px'>
            <Text fontSize='md' color={textColor} fontWeight='bold' me='10px'>
              Réseaux sociaux:{" "}
            </Text>
            <Flex>
              <Link
                href='#'
                color='#e1aa29'
                fontSize='lg'
                me='10px'
                _hover={{ color: "#e1aa29" }}>
                <Icon as={FaFacebook} />
              </Link>
              <Link
                href='#'
                color='#e1aa29'
                fontSize='lg'
                me='10px'
                _hover={{ color: "#e1aa29" }}>
                <Icon as={FaInstagram} />
              </Link>
              <Link
                href='#'
                color='#e1aa29'
                fontSize='lg'
                me='10px'
                _hover={{ color: "#e1aa29" }}>
                <Icon as={FaTwitter} />
              </Link>
            </Flex>
          </Flex> */}
        </Flex>
      </CardBody>
    </Card>
  );
};

export default ProfileInformation;
